import {Button} from '@wandb/weave/components/Button';
import {capitalizeFirst} from '@wandb/weave/core/util/string';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {useWorkspaceTemplateDrawerContext} from './WorkspaceTemplateDrawerContextProvider';

export const WorkspaceTemplateContentHeader = () => {
  const {closeWorkspaceTemplateDrawer, workspaceTemplateMode} =
    useWorkspaceTemplateDrawerContext();

  return (
    <div
      className={twMerge(
        'flex items-center justify-between',
        'px-20 py-16',
        'border-b-[1px] border-solid border-wb-border'
      )}>
      <h1 className={twMerge('text-xl font-semibold leading-[32px]')}>
        {capitalizeFirst(workspaceTemplateMode)} personal workspace template
      </h1>
      <Button
        aria-label="Close template drawer"
        variant="ghost"
        icon="close"
        onClick={closeWorkspaceTemplateDrawer}
      />
    </div>
  );
};
